<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--ballot">
    <main>
      <h1 class="vtz-h1 vtz-text--center" i18n>
        Change 2-Factor Authentication
      </h1>
      <div>
        <mat-horizontal-stepper [linear]="isLinear" #stepper>
          <mat-step [editable]=false [completed]="false">
            <ng-template matStepLabel i18n>Select</ng-template>
            <mat-radio-group class="mfa-radio-group" color="primary" [(ngModel)]="chosenMfaMethod" aria-label="Select a 2-factor authentication option">
              <mat-radio-button value="APP" i18n>Authenticator App</mat-radio-button>
              @if(isEmailMfaSetupEnabled()) {
                <mat-radio-button value="EMAIL" i18n>Email</mat-radio-button>
              }
            </mat-radio-group>
            <div class="vtz-actions">
              <div class="button-group">
                <button i18n class="button-secondary" (click)="cancel()">CANCEL</button>
                <div class="vtz-spacer-10"></div>
                <button class="button button-primary" (click)="postMFAMethod()" i18n="Button label">
                  NEXT
                </button>
              </div>
            </div>
          </mat-step>
          <mat-step [editable]=false>
           
            <ng-container>
              <ng-template matStepLabel i18n>Verify</ng-template>
              @if(chosenMfaMethod === 'APP' && !qrScanned) {
                <div class="digits-header">
                  <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Set up your 6-digit authentication code using Google Authenticator, Microsoft Authenticator, OneAuth, or other authentication application.</p>
                  @if(isNotMobileScreen) {
                    <p class="vtz-text vtz-text--wide vtz-text--center" i18n><strong>ON A LAPTOP OR DESKTOP:</strong> Scan the QR code using a mobile device.</p>
                    <p class="vtz-text--center"><img src="{{electorDataService.qrCodeURL()}}" alt="QR Code"></p>
                  }
                  @if(!isIOS() && isNotBigScreen) {
                    <p class="vtz-text vtz-text--wide vtz-text--center" i18n><strong>ON A MOBILE DEVICE: </strong> <a href="{{electorDataService.authAppURL()}}">CLICK HERE</a>.</p>
                  }
                  <p class="vtz-text vtz-text--wide vtz-text--center" i18n><strong>FOR MANUAL SETUP:</strong> Add the following setup key in an authenticator app.</p>
                  <div class="vtz-text vtz-text--wide vtz-text--center center-list ">
                    <ul class="align-ul">
                      <li i18n>Press "COPY KEY" to copy the set up key or tap ●●●●●● to reveal the setup key for transcription.</li>
                      <li i18n>Open your authenticator app and tap the "+" button, "Add account," or "Set up account" option.</li>
                      <li i18n>Select "Enter a setup key" or "Manual entry" (not QR code scanning).</li>
                      <li i18n>Fill in the account information and paste the setup key.</li>
                      <li i18n>Tap "Add" or "Save" and the app should immediately start generating 6-digit codes that refresh every 30 seconds.</li>
                    </ul>
                  </div>
                  <div class="token-container">
                    <button class="code-toggle-btn" (click)="showCode = !showCode">
                      {{ showCode ? token : '●●●●●●' }}
                    </button>
                    <!-- <div id="button-group" class="button-group">
                     
                    </div> -->
                  </div>
                </div>
              } @else {
                @if(chosenMfaMethod === 'EMAIL'){
                  <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
                    Please enter the 6-digit code that was sent to you by email.
                  </p>
                } @else if(chosenMfaMethod === 'SMS'){
                  <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
                    Please enter the 6-digit code that was sent to you by text.
                  </p>
                } @else {
                  <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
                    Please enter the 6-digit code in your authenticator app.
                  </p>
                }
                <div class="vtz-form"> 
                  <div id="otp" class="otp-field">
                    @for (index of numbers; track index) {
                      <input
                        #mfaRef
                        type="text"
                        maxlength="1"
                        pattern="[0-9]"
                        required
                        [attr.aria-label]="'Digit' +(index + 1)+ 'of 6'"               
                        autocomplete="off"
                        (focus)="handleFocus($event)"
                        (input)="handleInput($event, index)"
                        (paste)="handlePaste($event)"
                        (blur)="index === 5 && handleBlur($event)"
                        (keydown)="handleKeydown($event, index)"
                        inputmode="numeric"
                      />
                    }
                  </div>
        
                  @if(mfaFormGroup.get('code')?.hasError('invalidPaste')){
                    <div role="alert" class="vtz-text--center">
                      <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field" >Pasted code must contain exactly 6 numbers.
                      </span>
                    </div>
                  }
                  @if(mfaFormGroup.get('code')?.hasError('invalidCode')){
                    <div role="alert" class="vtz-text--center">
                      <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Exactly six digits are required in this field.
                      </span>
                    </div>
                  }
        
                </div>
                @if(electorDataService.userAuthData()?.mfaMethod !== 'APP') {
                  <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
                    Your code will expire in {{electorDataService.mfaExpirationTimeMinutes()}} minutes.
                  </p>
                  @if(!maxMFAResendsReached && allowResends) {
                    <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
                      Have you received your MFA code? <strong><a style="cursor:pointer" class="light_red" (click)="resendOTP()">Send it again.</a></strong>
                    </p>
                  }
                }
              }
              <div class="vtz-actions">
                <div id="button-group" class="dialog-button-container">
                  <button class="button button-secondary-group" (click)="cancel()" i18n="Button label">
                    CANCEL
                  </button>
                  @if(chosenMfaMethod === 'APP') {
                    @if(!qrScanned) {
                      <button (click)="copySecret()" class="button button-secondary-group" i18n>COPY KEY</button>
                      <button class="button button-primary" (click)="toCodeEntry()" i18n="Button label">
                        CONTINUE
                      </button>
                    } @else {
                      <button class="button button-primary" (click)="backToQR()" i18n="Button label">
                        BACK
                      </button>
                      <button class="button button-primary" [disabled]="mfaFormGroup.invalid || maxMFACodeAttemptsReached" (click)="verifyCode()" i18n="Button label">VERIFY</button>
                    }
                  } @else {
                    <button class="button button-primary" [disabled]="mfaFormGroup.invalid || maxMFACodeAttemptsReached" (click)="verifyCode()" i18n="Button label">VERIFY</button>
                  }
                </div>
              </div>
            </ng-container>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </main>
  </div>
  @if (displaySpinner) {
    <div class="progressSpinner">
      <mat-spinner [diameter]="300" color="primary"></mat-spinner>
      <div class="spinner-warning">
        <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
      </div>
    </div>
  }
</div>